import { PlateEditor } from "@udecode/plate";
import { ATTICUS_CLIPBOARD_CUSTOM_FORMAT } from "../createCustomClipboardPlugin";

// Unique identifier for Atticus
const ATTICUS_IDENTIFIER = "data-atticus-fragment";

export const withCustomClipboard = <T extends PlateEditor>(
  editor: T
): PlateEditor => {
  const { setFragmentData } = editor;

  /**
   * Override the editor's setFragmentData method to include our custom format
   * This runs whenever content is copied/cut from the editor
   */
  editor.setFragmentData = (data: DataTransfer) => {
    // Extract and serialize selected content
    const selectedFragments = editor.getFragment();
    const string = JSON.stringify(selectedFragments);

    // Encode the JSON string to base64 to ensure safe and standard clipboard transfer
    // First URI encode to handle special characters, then base64 encode
    const encoded = window.btoa(encodeURIComponent(string));

     // Add our custom format {ATTICUS_CLIPBOARD_CUSTOM_FORMAT} to the clipboard data
    data.setData(ATTICUS_CLIPBOARD_CUSTOM_FORMAT, encoded);

    // Call the default method first to generate standard formats
    setFragmentData(data);

    // After the default method runs, modify the text/html to include atticus identifier (safari fix)
    const htmlData = data.getData("text/html");
    if (htmlData) {
      // Parse the HTML to add custom attribute
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlData;
      
      // Add Atticus identifier to the root element or create a wrapper
      const rootElement = tempDiv.firstElementChild;
      if (rootElement) {
        rootElement.setAttribute(ATTICUS_IDENTIFIER, encoded);
      } else {
        // If no root element, wrap the content
        tempDiv.innerHTML = `<div ${ATTICUS_IDENTIFIER}="${encoded}">${htmlData}</div>`;
      }
      
      // Update the clipboard with modified HTML
      data.setData("text/html", tempDiv.innerHTML);
    }
  };

  return editor;
};